import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, flatMap, map, mergeMap, Observable, Subscription } from 'rxjs';
//import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Globals } from 'src/app/shared/globals';
import { SideNavbarService } from 'src/app/side-navbar/side-navbar.service';
import { environment } from '../../../environments/environment';
import { EducationService } from '../education.service';

@Component({
  selector: 'educations-by-education-type',
  templateUrl: './educations-by-education-type.component.html',
  styleUrls: ['./educations-by-education-type.component.css']
})
export class EducationsByEducationTypeComponent implements OnInit {

  @Input('unit') id!: any;
  units: any;
  isLoaded!: boolean;
  educations!: any;
  educationType!: any;
  period: any;
  panelOpenState = false;
  private subscription: Subscription = new Subscription();

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private navigationService: SideNavbarService,
    private educationService: EducationService,
    private titleService: Title
  ) { 
    route.params.subscribe(params => {
      /** Tällä tavoin voidaan kiertää ongelmaa, jossa nopea klikkailu
      /*  johtaa siihen, että aikaisemman ngOnInitin hakutulokset tulevat 
      /*  viiveellä. RouteReuseStrategy ei toiminut jostain syystä. */
      this.subscription.unsubscribe();
      this.subscription = new Subscription();
      this.ngOnInit();
    })
  }

  ngOnInit(): void {
    // tällä saadaan aikaan latauspalkki
    this.subscription.add(this.route.url.subscribe(url => {
      this.isLoaded = false;
    }));
    
    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        id: params[0].get('id'), 
        period: params[1].get('period')
      })),
      // koulutustyypin tietojen hakeminen
      mergeMap(params => {
        //this.isLoaded = false;
        //console.log(params.id);
        this.id = params.id;
        this.period = params.period;
        return this.educationService.getEducationsByEducationType(this.id);
      }),
      mergeMap(educations => {
        this.educations = educations;
        this.globals.sortByName2(educations, this.globals.lang);
        this.educations.forEach((education: { children: any[]; }) => {
          this.globals.sortByName2(education.children, this.globals.lang);
        })
        return this.navigationService.getNavigationItem(this.id);
      })).subscribe(navigationItem => {
        this.educationType = navigationItem;
        this.setTitle();
        this.setCurrentUrl();
        this.isLoaded = true;
        
      }
      ));

      
      /*this.subscription.add(this.route.params.subscribe(params => {
        if (params['lang'] === 'fi') {
          this.globals.lang = 'fi'
        }
        if (params['lang'] === 'en') {
          this.globals.lang = 'en'
        }
        if (params['lang'] === 'sv') {
          this.globals.lang = 'sv'
        }
      }));*/
      this.subscription.add(this.globals.setLangFromRoute(this.route));



  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
     * Päätellääm koulutus kaksiportaiseksi, jos se sisältää ainakin yhden 
     * BA-tasoisen ja ainakin yhden muu-tasoisen tutkinnon.
     * @param units 
     */
   isTwoCycleDegree(units: any[]) {
      
    let bachelor = false;
    let other = false;
    units.forEach(unit => {
      if (unit.educationLevel != null) {
        if(unit.educationLevel == 'BA') {
          bachelor = true;
        } else {
          other = true;
        }
      }
    });
    //console.log(bachelor);
    return bachelor && other;
  }

  setTitle() {
    if (this.period) {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.educationType.name) + environment.titleExtension + ' ' + this.period);
    } else {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.educationType.name) + environment.titleExtension);
    }
  }


  setCurrentUrl() {
    
      if (!this.period) {
        this.globals.currentUrl = {
          valueFi:'/fi/' + this.globals.toKebabCase(this.educationType.name.valueFi) + '/' + this.educationType.id, 
          valueEn:'/en/' + this.globals.toKebabCase(this.educationType.name.valueEn) + '/' + this.educationType.id, 
          valueSv:'/sv/' + this.globals.toKebabCase(this.educationType.name.valueSv) + '/' + this.educationType.id
        };
      } else {           
        this.globals.currentUrl = {
          valueFi:'/fi/' + this.globals.toKebabCase(this.educationType.name.valueFi) + '/' + this.educationType.id + '?period=' + this.period, 
          valueEn:'/en/' + this.globals.toKebabCase(this.educationType.name.valueEn) + '/' + this.educationType.id + '?period=' + this.period, 
          valueSv:'/sv/' + this.globals.toKebabCase(this.educationType.name.valueSv) + '/' + this.educationType.id + '?period=' + this.period
        }
      }
    //this.globals.createLinkForCanonicalURL();
  } //end of setCurrentUrl()




}
